import { createSlice } from "@reduxjs/toolkit";
import { call, put } from "redux-saga/effects";
import { companyType } from "../../../types/comapnyTypes";
import { ApiResType } from "../../../types/apiTypes";
import { getCompanyList } from "../../../api/company/companyReq";

type sliceStateType = {
  loading: boolean;
  data: companyType[];
  error: boolean;
  message: string;
};

const initialState: sliceStateType = {
  loading: false,
  data: [],
  error: false,
  message: "",
};

const ClientsListSlice = createSlice({
  name: "ClientsList",
  initialState: initialState,
  reducers: {
    AddClientsList: (state, { payload }: { payload: companyType[] }) => {
      state.data = payload;
      return state;
    },
    StartLoading: (state) => {
      state.loading = true;
      return state;
    },
    StopLoading: (state) => {
      state.loading = false;
      return state;
    },
  },
});

export const { AddClientsList, StartLoading, StopLoading } =
  ClientsListSlice.actions;

export default ClientsListSlice.reducer;

export function* getClientsListAction() {
  try {
    yield put(StartLoading());
    const res: ApiResType = yield call(getCompanyList);
    yield put(AddClientsList(res?.data));
    return true;
  } catch (error: any) {
    yield put(StopLoading());
    yield put(AddClientsList([]));
    return false;
  }
}
